import { NgModule } from '@angular/core';
import { UserContactService } from './services/user-contact.service';

@NgModule({
	providers: [UserContactService]
})
export class UserContactModule { }
